import { doPost } from './common'
/*
    Services for CompleteStep
*/

/*
    returns a promise with payload
    {
        success: Boolean
        detail: Object
    }

*/
export const start = (breakId, stepId) => {
  const payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/complete/start/`, payload)
}

export const complete = (breakId, stepId) => {
  const payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/complete/complete/`, payload)
}
